import { render, staticRenderFns } from "./DeshopSocial.vue?vue&type=template&id=047ce346&scoped=true&"
import script from "./DeshopSocial.vue?vue&type=script&lang=js&"
export * from "./DeshopSocial.vue?vue&type=script&lang=js&"
import style0 from "./DeshopSocial.vue?vue&type=style&index=0&id=047ce346&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047ce346",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fdeshop-social%2FDeshopSocial.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports